
import React, { useEffect } from "react";
import {connect} from 'react-redux';
import {getMapLevelWeightageData} from "../../../redux/actions/dataAction";
import CustomTableWithAll from "../../../constants/CustomTableWithAll";
import CustomHeading from "../../../constants/CustomHeading";

const Map_Level_Weightage = (props) => {
  useEffect(()=>{
    props.getMapLevelWeightageData()
    console.log(props?.mapLevelWeightage?.data)
  },[])
  const columns = [ 
    {title: "Name",field:"name"},
    {title:"Acronym",field:"acronym"},
    {title:"Status",field:"status"},
    {title:"Weightage",field:"weightage"},
    {title:'Created By',field:'created_by'},
  ]
  
  return (
    <div className="customContainer">
    <CustomHeading title="Map Level Weightage"/>
    <CustomTableWithAll data={props?.mapLevelWeightage?.data} buttonRequired={true} buttonLabel="ADD" columns={columns} api="/api/maplevel-weightage/" identify="MapLevelWeightage" title="Map Level Weightage"/>
  </div>
  );
};

const mapActionWithProps = {
  getMapLevelWeightageData
}

const mapStateWithProps = (state)=>(
  {
    mapLevelWeightage:state.data.mapLevelWeightage
  }
)
export default connect(mapStateWithProps,mapActionWithProps) (Map_Level_Weightage);
